export function parseBlocks(blocks: string) {
    try {
        const output = JSON.parse(blocks);
        return output.blocks || [];
    } catch {
        return [];
    }
}
